import { Breadcrumbs, Link as MuiLink } from '@mui/material'

import { Link } from 'react-router-dom'

import './index.css'

const BreadcrumbsComponent = ({ value=[], config={}, events={} }) => {
    return (
        <div className="c-Breadcrumbs">
            <Breadcrumbs separator={config.separator || '/'}>
                {value.map((item, index) => (
                    item.to ? (
                        <MuiLink key={`breadcrumb-${index}`} component={Link} to={item.to} underline="hover" color="inherit">
                            {item.label}
                        </MuiLink>
                    ) : (
                        <span key={`breadcrumb-${index}`} className="breadcrumbs-current">{item.label}</span>
                    )
                ))}
            </Breadcrumbs>
        </div>
    )
}

export { BreadcrumbsComponent }
